import React from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox, FormControlLabel } from '@mui/material';

const FieldCheckbox = ({ label = '', control, name, disabled, rules }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={false}
      render={({ field, fieldState }) => (
        <FormControlLabel
          sx={{ mr: -1.5 }}
          label={label}
          disabled={disabled}
          control={
            <Checkbox
              {...field}
              checked={!!field.value}
              onChange={(e) => field.onChange(e.target.checked)}
            />
          }
        />
      )}
    />
  );
};

export default FieldCheckbox;
